export const ADD_PRIMARY_IMAGE_URL = 'ADD_PRIMARY_IMAGE_URL';
export const ADD_PROMO = 'ADD_PROMO';
export const ADD_VIDEO = 'ADD_VIDEO';
